var $ = require('jquery');

$(function(){
  'use strict';

  var $header = {}
  $header.main = $('.js-c-Header');
  $header.toggle = $('.js-c-Header__toggle');
  $header.nav = $('.js-c-Header__wrap');


  $(window).scroll(function(){
    var scrollPosition = $(this).scrollTop();

    if(scrollPosition > 100) {
      $header.main.addClass('is-change');
    } else {
      $header.main.removeClass('is-change');
    }

    if(scrollPosition > 200) {
      $header.main.addClass('is-fixed');
    } else {
      $header.main.removeClass('is-fixed');
    }

    if(scrollPosition > 300) {
      $header.main.addClass('is-show');
    } else {
      $header.main.removeClass('is-show');
    }
  });

  var st;
  $header.toggle.on('click', function(){

    if($header.main.hasClass('is-active')) {
      $('body').removeClass('scroll-prevent');
      $(window).scrollTop(st);
      $header.main.removeClass('is-active');

    } else {
      st = $(window).scrollTop();
      $('body').addClass('scroll-prevent');
      $header.main.addClass('is-active');

    }
  });

  $('.js-c-Header__contactMail').on('click', function(){
    if($header.main.hasClass('is-active')) {
      $header.main.removeClass('is-active');
    }
  });

});

